import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';

let comite_state;

class Comites extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            nombre_comite: ''
        }

        
        

        comite_state = this;

    }

    componentDidMount(){
        
        switch(window.location.href.substring(window.location.href.length -1)){
            case '1': comite_state.setState({nombre_comite: 'Comité de Seguridad Vial'}); break;
            case '2': comite_state.setState({nombre_comite: 'Comité de Prevención y Combate al Delito'}); break;
            case '3': comite_state.setState({nombre_comite: 'Comité de Movilidad'}); break;
            case '4': comite_state.setState({nombre_comite: 'Comité Ferroviario'}); break;
            case '5': comite_state.setState({nombre_comite: 'Comité Jurídico'}); break;
            case '6': comite_state.setState({nombre_comite: 'Comité Técnico'}); break;
            default: comite_state.setState({nombre_comite: 'Comites'}); break;
        }

    }

    cambiarNombreComite(e){
        
        switch(e.target.text){
            case 'CNSV': comite_state.setState({nombre_comite: 'Comité de Seguridad Vial'}); break;
            case 'CPyCD': comite_state.setState({nombre_comite: 'Comité de Prevención y Combate al Delito'}); break;
            case 'CM': comite_state.setState({nombre_comite: 'Comité de Movilidad'}); break;
            case 'CF': comite_state.setState({nombre_comite: 'Comité Ferroviario'}); break;
            case 'CJ': comite_state.setState({nombre_comite: 'Comité Jurídico'}); break;
            case 'CT': comite_state.setState({nombre_comite: 'Comité Técnico'}); break;
            default: comite_state.setState({nombre_comite: 'Comites'}); break;
        }
    }


    render(){
        return(
            <Row>
    
                 
                {<Col span={20} offset={2} style={{ textAlign: 'center'}}>
                <Breadcrumb>
                    <Breadcrumb.Item>
                    <Link onClick={ comite_state.cambiarNombreComite}
                        to={{
                            pathname: '/login/comite-nacional-seguridad-vial/1',
                          }}
                    >CNSV</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                    <Link onClick={ comite_state.cambiarNombreComite}
                        to={{
                            pathname: '/login/comite-prevencion-y-combate-al-delito/2',
                          }}
                    >CPyCD</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>
                    <Link onClick={ comite_state.cambiarNombreComite}
                        to={{
                        pathname: '/login/comite-movilidad/3',
                        }}
                    >CM</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>
                    <Link onClick={ comite_state.cambiarNombreComite}
                        to={{
                            pathname: '/login/comite-ferroviario/4',
                          }}
                        >CF</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>
                    <Link onClick={ comite_state.cambiarNombreComite}
                        to={{
                            pathname: '/login/comite-juridico/5',
                          }}
                    >CJ</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>
                    <Link onClick={ comite_state.cambiarNombreComite}
                        to={{
                            pathname: '/login/comite-tecnico/6',
                          }}
                    >CT</Link></Breadcrumb.Item>
                </Breadcrumb>
                </Col>}
            
                {/*<Col span={20} offset={2}><h1 style={{textAlign:'center'}}><br />{comite_state.state.nombre_comite}<br /><br /></h1></Col>*/}
            </Row>
        );
    }
}

export default Comites;